<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px; font-size: small;">
      <div class="card">
        <div class="card-header" style="background-color: #DBECDB;">
          <div class="row">
            <h5 class="card-title col-md-5">Detalles de Compra #{{ compra.nro_preventivo }}</h5>
            <div class="col-md-7" style="text-align: right;">
              <button
                @click="$router.go(-1)"
                class="btn btn-secondary btn-sm"
              >
                <i class="fa fa-arrow-left me-1"></i> Volver
              </button>
              <BButton style="text-align: right;"
                v-if="compra.estado == 'Iniciado'"
                variant="warning"
                class="btn btn-sm"
                @click="finalizarCompra(compra.id)"
              > Finalizar Compra
              </BButton>
              <BButton
                v-if="compra.estado == 'Finalizado'"
                variant="danger"
                class="btn btn-sm"
                @click="generateActaPDF(compra.id)"
              >
                <i class="fa fa-file-pdf me-1"></i> Imprimir Acta
              </BButton>
            </div>
          </div>

        </div>

        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>

          <div v-else>
            <div class="row mb-4">
              <div class="col-md-3">
                <p><strong>Fecha:</strong> {{ formatDate(compra.fecha_compra) }}</p>
                <p><strong>Preventivo:</strong> {{ compra.nro_preventivo }}</p>
                <p><strong>Partida:</strong> {{ compra.categoria.id_partida }}</p>
              </div>
              <div class="col-md-9">
                <p><strong>Proveedor:</strong> {{ compra.proveedores.razon_social }}</p>
                <p><strong>Categoría:</strong> {{ compra.categoria.nombre_categoria }}</p>
                <p><strong>Detalle de Compra:</strong> {{ compra.acta_entrega || 'N/A' }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5>Items de la Compra</h5>
                  <BButton
                    v-if="compra.estado == 'Iniciado' && hasPermission('compra_create')"
                    @click="showItemModal(null)"
                    variant="success"
                    size="sm"
                  >
                    <i class="fa fa-plus me-1"></i> Nuevo Item
                  </BButton>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Cantidad</th>
                        <th>Unidad</th>
                        <th>Costo Unitario</th>
                        <th>Subtotal</th>
                        <th v-if="compra.estado == 'Iniciado'">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detalle, index) in compra.detalles" :key="index">
                        <td>{{ detalle.item.codigo }} : {{ detalle.item.nombre_item }}</td>
                        <td>{{ detalle.cantidad }}</td>
                        <td>{{ detalle.item.unidad_medida }}</td>
                        <td>{{ detalle.costo_unitario }} Bs.</td>
                        <td>{{ (detalle.cantidad * detalle.costo_unitario).toFixed(2) }} Bs.</td>
                        <td v-if="compra.estado == 'Iniciado' && hasPermission('compra_create')">
                          <button
                            @click="confirmDeleteItem(detalle)"
                            class="btn btn-danger btn-sm"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="4" class="text-end"><strong>Total:</strong></td>
                        <td><strong>{{ calculateTotal(compra.detalles).toFixed(2) }} Bs.</strong></td>
                        <td v-if="compra.estado == 'Iniciado'"  ></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para agregar/editar item -->
    <BModal
      v-model="itemModalVisible"
      :title="itemModalTitle"
      size="lg"
      centered
      hide-footer
    >
      <form @submit.prevent="handleItemSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Item</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': itemErrors.id_item }"
                  v-model="itemSearchText"
                  placeholder="Buscar por código o nombre del ítem..."
                  @input="onItemSearch"
                  @focus="onItemFocus"
                  @blur="hideSuggestions"
                  @keydown.down.prevent="selectNextSuggestion"
                  @keydown.up.prevent="selectPrevSuggestion"
                  @keydown.enter.prevent="applySelectedSuggestion"
                  autocomplete="off"
                />
                <i class="fa fa-search position-absolute" style="right: 12px; top: 50%; transform: translateY(-50%); color: #6c757d;"></i>

                <!-- Lista de sugerencias -->
                <div v-if="showSuggestions && filteredItems.length > 0" class="suggestions-list">
                  <div
                    v-for="(item, index) in filteredItems"
                    :key="item.id"
                    class="suggestion-item"
                    :class="{ active: selectedSuggestionIndex === index }"
                    @mousedown.prevent="selectSuggestion(item)"
                    @mouseenter="selectedSuggestionIndex = index"
                  >
                    <div class="d-flex align-items-center">
                      <div>
                        <span>{{ item.codigo }} - {{ item.nombre_item }} ({{ item.unidad_medida || 'N/A' }})</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="showSuggestions && itemSearchText.length > 1 && filteredItems.length === 0" class="suggestions-list">
                  <div class="suggestion-item text-muted text-center py-2">
                    <i class="fa fa-exclamation-circle me-2"></i>
                    No se encontraron ítems con "{{ itemSearchText }}"
                  </div>
                </div>
              </div>
              <div class="invalid-feedback" v-if="itemErrors.id_item">{{ itemErrors.id_item[0] }}</div>
              <small class="text-muted">Escribe para buscar por código o nombre del ítem</small>
            </div>
          </div>
        </div>

        <!-- Información del ítem seleccionado -->
        <div v-if="selectedItemInfo" class="row mt-2">
          <div class="col-12">
            <div class="alert alert-info p-2 d-flex justify-content-between align-items-center">
              <div>
                <i class="fa fa-check-circle text-success me-2"></i>
                <strong>Ítem seleccionado:</strong>
                <span class="">{{ selectedItemInfo.codigo }}</span>
                {{ selectedItemInfo.nombre_item }}
                <span v-if="selectedItemInfo.unidad_medida" class="ms-2">
                  <strong>Unidad:</strong> {{ selectedItemInfo.unidad_medida }}
                </span>
              </div>
              <BButton size="sm" variant="outline-secondary" @click="clearSelectedItem" title="Limpiar selección">
                <i class="fa fa-times"></i>
              </BButton>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Cantidad</label>
              <input
                type="number"
                v-model="itemForm.cantidad"
                min="1"
                class="form-control"
                :class="{ 'is-invalid': itemErrors.cantidad }"
                required
              />
              <div class="invalid-feedback" v-if="itemErrors.cantidad">{{ itemErrors.cantidad[0] }}</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Costo Unitario (Bs.)</label>
              <input
                type="number"
                v-model="itemForm.costo_unitario"
                min="0"
                step="0.01"
                class="form-control"
                :class="{ 'is-invalid': itemErrors.costo_unitario }"
                required
              />
              <div class="invalid-feedback" v-if="itemErrors.costo_unitario">{{ itemErrors.costo_unitario[0] }}</div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="itemModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingItemForm || !itemForm.id_item"
          >
            <span v-if="loadingItemForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditingItem ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton } from 'bootstrap-vue-3';

const route = useRoute();
const router = useRouter();
// Store
const authStore = useAuthStore();
// Datos
const compra = ref({ detalles: [] });
const items = ref([]);
const loading = ref(true);
const loadingItemForm = ref(false);
const itemModalVisible = ref(false);
const isEditingItem = ref(false);

// Formulario de item
const itemForm = ref({
  id: null,
  id_item: '',
  cantidad: 1,
  costo_unitario: 0
});

// Errores del formulario
const itemErrors = ref({});

// Búsqueda de ítems
const itemSearchText = ref('');
const filteredItems = ref([]);
const showSuggestions = ref(false);
const selectedSuggestionIndex = ref(-1);
const selectedItemInfo = ref(null);

// Computed properties
const hasPermission = (permission) => {
  return authStore.user?.permissions?.includes(permission);
};

// Computed
const itemModalTitle = computed(() => {
  return isEditingItem.value ? 'Editar Item' : 'Nuevo Item';
});

// ==================== MÉTODOS DE BÚSQUEDA DE ÍTEMS ====================
const onItemSearch = (event) => {
  const search = event.target.value.toLowerCase().trim();
  selectedSuggestionIndex.value = -1;

  if (!search || search.length < 1) {
    filteredItems.value = items.value.slice(0, 20);
    showSuggestions.value = true;
    return;
  }

  filteredItems.value = items.value.filter(item =>
    item.codigo.toLowerCase().includes(search) ||
    item.nombre_item.toLowerCase().includes(search)
  ).slice(0, 50);

  showSuggestions.value = true;
};

const onItemFocus = () => {
  showSuggestions.value = true;
  if (filteredItems.value.length === 0) {
    filteredItems.value = items.value.slice(0, 20);
  }
};

const hideSuggestions = () => {
  setTimeout(() => {
    showSuggestions.value = false;
  }, 200);
};

const selectNextSuggestion = () => {
  if (selectedSuggestionIndex.value < filteredItems.value.length - 1) {
    selectedSuggestionIndex.value++;
  }
};

const selectPrevSuggestion = () => {
  if (selectedSuggestionIndex.value > 0) {
    selectedSuggestionIndex.value--;
  }
};

const applySelectedSuggestion = () => {
  if (selectedSuggestionIndex.value >= 0 && selectedSuggestionIndex.value < filteredItems.value.length) {
    selectSuggestion(filteredItems.value[selectedSuggestionIndex.value]);
  }
};

const selectSuggestion = (item) => {
  itemForm.value.id_item = item.id;
  selectedItemInfo.value = item;
  itemSearchText.value = `${item.codigo} - ${item.nombre_item}`;
  showSuggestions.value = false;
  itemErrors.value.id_item = null;
};

const clearSelectedItem = () => {
  itemForm.value.id_item = '';
  selectedItemInfo.value = null;
  itemSearchText.value = '';
  filteredItems.value = items.value.slice(0, 20);
};

// ==================== MÉTODOS PRINCIPALES ====================
const fetchCompra = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/compras/${route.params.id}/ver`);
    compra.value = response.data.data;
  } catch (error) {
    console.error('Error al cargar compra:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudieron cargar los detalles de la compra'
    });
    router.push({ name: 'compras' });
  } finally {
    loading.value = false;
  }
};

const fetchItems = async () => {
  try {
    const response = await axios.get('/compras/items/list');
    items.value = response.data.data;
    filteredItems.value = items.value.slice(0, 20);
  } catch (error) {
    console.error('Error al cargar items:', error);
  }
};

const showItemModal = (item) => {
  itemErrors.value = {};
  itemForm.value = {
    id: null,
    id_item: '',
    cantidad: 1,
    costo_unitario: 0
  };
  itemSearchText.value = '';
  selectedItemInfo.value = null;
  selectedSuggestionIndex.value = -1;
  showSuggestions.value = false;

  if (item) {
    isEditingItem.value = true;
    itemForm.value = {
      id: item.id,
      id_item: item.id_item,
      cantidad: item.cantidad,
      costo_unitario: item.costo_unitario
    };
    // Buscar el ítem seleccionado para mostrar su información
    const foundItem = items.value.find(i => i.id === item.id_item);
    if (foundItem) {
      selectedItemInfo.value = foundItem;
      itemSearchText.value = `${foundItem.codigo} - ${foundItem.nombre_item}`;
    }
  } else {
    isEditingItem.value = false;
  }
  itemModalVisible.value = true;
};

const handleItemSubmit = async () => {
  // Validar que se haya seleccionado un item
  if (!itemForm.value.id_item) {
    itemErrors.value.id_item = ['Debe seleccionar un ítem'];
    return;
  }

  loadingItemForm.value = true;
  itemErrors.value = {};

  try {
    let response;

    if (isEditingItem.value && itemForm.value.id) {
      response = await axios.post(`/compras/${compra.value.id}/items/${itemForm.value.id}/update`, itemForm.value);
    } else {
      response = await axios.post(`/compras/${compra.value.id}/items/save`, itemForm.value);
    }

    Swal.fire({
      icon: 'success',
      title: 'Éxito',
      text: response.data.message
    });

    itemModalVisible.value = false;
    await fetchCompra();
  } catch (error) {
    console.error('Error al guardar item:', error);
    if (error.response?.status === 422) {
      itemErrors.value = error.response.data.errors;
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
      });
    }
  } finally {
    loadingItemForm.value = false;
  }
};

const confirmDeleteItem = (detalle) => {
  Swal.fire({
    title: '¿Eliminar item?',
    text: `¿Desea eliminar el item ${detalle.item.nombre_item} de esta compra?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      deleteItem(detalle);
    }
  });
};

const finalizarCompra = async (id) => {
  try {
    await axios.get(`/compras/${compra.value.id}/finalizar`);
    Swal.fire({
      icon: 'success',
      title: 'Éxito',
      text: 'Compra finalizada correctamente'
    });

    await fetchCompra();
  } catch (error) {
    console.error('Error al finalizar compara:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.message || 'Ocurrió un error al finalizar la Compra'
    });
  }
};

const deleteItem = async (detalle) => {
  try {
    await axios.get(`/compras/${compra.value.id}/items/${detalle.id}/delete`);

    Swal.fire({
      icon: 'success',
      title: 'Éxito',
      text: 'Item eliminado correctamente'
    });

    await fetchCompra();
  } catch (error) {
    console.error('Error al eliminar item:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.message || 'Ocurrió un error al eliminar el item'
    });
  }
};

const generateActaPDF = async (id) => {
  try {
      const response = await axios.get(`/compras/acta/${id}`, {
          responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'acta-compra.pdf';
      link.click();
      URL.revokeObjectURL(link.href);
  } catch (error) {
      console.error('Error al generar PDF:', error);
  }
};

const calculateTotal = (items) => {
  return items.reduce((total, item) => {
    return total + (item.cantidad * item.costo_unitario);
  }, 0);
};

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('es-BO', options);
};

// Watch para mantener actualizadas las listas de sugerencias
watch(items, (newItems) => {
  filteredItems.value = newItems.slice(0, 20);
});

// Ciclo de vida
onMounted(() => {
  fetchCompra();
  fetchItems();
});
</script>

<style scoped>
  .table-responsive {
    max-height: 500px;
    overflow-y: auto;
  }
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }

  /* Estilos para el autocomplete */
  .suggestions-list {
    position: absolute;
    z-index: 1060;
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border: 1px solid #ced4da;
    border-radius: 0 0 0.375rem 0.375rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    margin-top: 2px;
  }

  .suggestion-item {
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.15s;
  }

  .suggestion-item:hover,
  .suggestion-item.active {
    background-color: #e7f1ff;
  }

  .suggestion-item:last-child {
    border-bottom: none;
  }

  .suggestion-item .badge {
    font-size: 0.7rem;
  }

  /* Scroll personalizado */
  .suggestions-list::-webkit-scrollbar {
    width: 6px;
  }

  .suggestions-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .suggestions-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .suggestions-list::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Estilos para el input con icono de búsqueda */
  .position-relative .fa-search {
    pointer-events: none;
  }
</style>
